import { ref } from 'vue'

type ToastAction = {
  label: string
  handler: () => void
}

type ToastOptions = {
  message: string
  color?: string
  timeout?: number
  action?: ToastAction
}

const show = ref(false)
const message = ref('')
const color = ref('primary')
const timeout = ref(3000)
const action = ref<ToastAction | undefined>(undefined)

function triggerToast(options: ToastOptions) {
  message.value = options.message
  color.value = options.color || 'primary'
  timeout.value = options.timeout || 3_000
  action.value = options.action
  show.value = false
  requestAnimationFrame(() => {
    show.value = true
  })
}

function triggerErrorToast(message: string) {
  triggerToast({
    message: `Ha ocurrido un error: ${message}`,
    color: 'error',
  })
}

export const useToast = () => ({
  show,
  message,
  color,
  timeout,
  action,
  triggerToast,
  triggerErrorToast,
})
